import xhr from 'xhr'

export default async function getWelcomelist() {
  const res = await xhr(`/agreements?pagination[limit]=-1&populate=*`)
  return res.data.data
}
